
import { useCallback, useEffect, useMemo, useState } from "react";
import "chartjs-adapter-date-fns";
import ReactDOM from 'react-dom';
import {endOfYesterday,startOfMonth} from "date-fns";

import {Chip, LinearProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";
import useAuthenticatedRequest from "../../../../lib/useAuthenticatedRequest";
import { formatDateForServer, sumChartGroupData } from "../../../../lib/Utility";
import { generateDatasetsBar } from "../generateDatasets";
import ModalVariables from "../ModalVariables";
import { EnergyFooter } from "../EnergyFooter";
import { PERIODS } from "../settings";
import ChartBar from "./ChartBar";
import ModalVarParagon from "./ModalVarParagon";
import ModalEnergySite from "./ModalEnergySite";
import { transparentize } from "polished";

export default function IndexBar(props) {
  const {site, variablesList} = props

  const [paragonSiteID, setParagonSiteID] = useState(null) 
  const [paragonArray, setParagonArray] = useState([])
  const [sitesEnergy, setSitesEnergy] = useState([])
  const [openModalPar, setOpenModalPar] = useState(false)
  const [openModalEnergySite, setOpenModalEnergySite] = useState(false)
  const [varListParagon, setVarListParagon] = useState([])

  const [chartVars, setChartVars] = useState([])
  const [chartVarsPrevious, setChartVarsPrevious] = useState([]);
  const [chartVarsParagon, setChartVarsParagon] = useState([]);
  const [activeParagon, setActiveParagon] = useState(false)
  const [periodDayPrevious, setPeriodDayPrevious] = useState(28);

  const modalPortal = document.getElementById('modal-portal');
  
  const [{isLoading: LoadingEnergySites, data: energySites, error:errorEnergySites},] = useAuthenticatedRequest({
    method: "GET",
    url: "siteslist/1",
  });
  const [{isLoading: chartLoading, data: chartDataResponse}, triggerRequest] = useAuthenticatedRequest();
  const [{isLoading: isLoading28DaysAgo, data: chartDataPrevious}, triggerRequestPrevious] = useAuthenticatedRequest();
  const [{isLoading: loadingVariables, data: dataVariables}, triggerVariablesRequest,] = useAuthenticatedRequest(null);
  const [{isLoading: isLoadingParagon, data: chartDataParagon}, triggerRequestParagon] = useAuthenticatedRequest();

  useEffect(() => {
    if (paragonSiteID !== null) {
      setActiveParagon(true);
    }
  }, [paragonSiteID]);

  useEffect(() => {
    if (paragonSiteID) {
      triggerVariablesRequest({
        method: "POST",
        url: "dashboard",
        data: {siteID: Number(paragonSiteID),categoryID: 1},     
      });
    }
  }, [paragonSiteID, triggerVariablesRequest]);

  useEffect(() => {
    if (dataVariables) {
      setVarListParagon(dataVariables);
    }
  }, [dataVariables]);

    useEffect(() => {
      if(energySites !== null){
          setSitesEnergy(energySites);
      }
    }, [LoadingEnergySites, energySites]);


  const [variables, setVariables] = useState(
    variablesList.reduce((acc, {color, variable}) => ({
        ...acc,
        [variable.variable_id]: {
          id: variable.variable_id,
          color,
          name: [variable.device_name].join(" - "),
          hash: variable.variable_hash,
          avg: undefined,
        }
    }),{})
  );



  const fromStartOfMonth = (startOfMonth(new Date()) > endOfYesterday()) ? startOfMonth(endOfYesterday()) : startOfMonth(new Date());
  const toEndOfYesterday = endOfYesterday();

  // Recupera i valori dal localStorage o imposta i valori predefiniti
  const initialReportFromDate = sessionStorage.getItem('reportFromDate') ? new Date(sessionStorage.getItem('reportFromDate')) : fromStartOfMonth;
  const initialReportToDate = sessionStorage.getItem('reportToDate') ? new Date(sessionStorage.getItem('reportToDate')) : toEndOfYesterday;
  const initialSelectedFrequency = sessionStorage.getItem('selectedFrequency') || "24h";
  const initialCheckedVariables = sessionStorage.getItem('checkedVariables') ? JSON.parse(sessionStorage.getItem('checkedVariables')) : Object.keys(variables).map(Number);
  const initialSelectedPeriod = sessionStorage.getItem('selectedPeriod') ? sessionStorage.getItem('selectedPeriod') : PERIODS.LAST_MONTH;
 
  const [checkedVariables, setCheckedVariables] = useState(initialCheckedVariables);
  const [selectedPeriod, setSelectedPeriod] = useState(initialSelectedPeriod || PERIODS.LAST_MONTH);
  const [selectedFrequency, setSelectedFrequency] = useState(initialSelectedFrequency || "24h");
  const [reportToDate, setReportToDate] = useState(initialReportToDate || toEndOfYesterday);
  const [reportFromDate, setReportFromDate] = useState(initialReportFromDate || fromStartOfMonth);

  useEffect(() => {
    if(chartDataResponse !== null){
      const vars = (chartDataResponse.vars).filter(item => checkedVariables.includes(item.idvar))
      setChartVars(vars)
    }   
  }, [chartDataResponse,checkedVariables]);

  useEffect(() => {
    if (chartDataPrevious !== null) {
      const varsPrevious = (chartDataPrevious.vars).filter(item => checkedVariables.includes(item.idvar));
      setChartVarsPrevious(varsPrevious);
    }
  }, [chartDataPrevious, checkedVariables]);

  useEffect(() => {
    if (paragonSiteID !== null && chartDataParagon && chartDataParagon.vars) {
      const varsPar = chartDataParagon.vars;
      setChartVarsParagon(varsPar);
    }
  }, [paragonSiteID, chartDataParagon]);
 
  useEffect(() => {
    if (paragonSiteID !== 0 && paragonArray.length !== 0) {
      const paragoniIDVar = paragonArray.flatMap(a => a.paragoni);

      const dataParagonSite = {
        siteID: Number(paragonSiteID),
        categoryID: 1, // 1 -> Energy
        step: selectedFrequency,
        dateStart: formatDateForServer(reportFromDate.toISOString()),
        dateEnd: formatDateForServer(reportToDate.toISOString()),
        ids: paragoniIDVar.map(String),
      };
    triggerRequestParagon({ method: "POST", url: "chart-bar-data", data: dataParagonSite });
  }
  },[paragonSiteID, paragonArray,reportFromDate,reportToDate,selectedFrequency])
  
  const onClickParagon = useCallback(() => {
    setActiveParagon(!activeParagon)
  },[activeParagon])
  ////FUNZIONE PER LA RICERCA IN BASE ALLA DATA
  const search = useCallback(() => {
    if (checkedVariables.length > 0) {
      ///setta il periodDayPrevious in base al periodo selezionato
      let periodDayPrevious = 28
      if (selectedPeriod === "MONTH" || selectedPeriod === "LAST_MONTH") {
        periodDayPrevious = 28;
      } else if (selectedPeriod === "ANNUAL") {
        periodDayPrevious = 365;
      } else {
        periodDayPrevious = 28;
      }
      
      const data = {
        siteID: Number(site.id),
        categoryID: 1, // 1 -> Energy
        step: selectedFrequency,
        dateStart: formatDateForServer(reportFromDate.toISOString()),
        dateEnd: formatDateForServer(reportToDate.toISOString()),
        ids: checkedVariables.map(String),
      };

      triggerRequest({method: "POST", url: "chart-bar-data", data});
   
      const reportFromDatePrevious = new Date(reportFromDate);
      reportFromDatePrevious.setDate(reportFromDate.getDate() - periodDayPrevious);
  
      const reportToDatePrevious = new Date(reportToDate);
      reportToDatePrevious.setDate(reportToDate.getDate() - periodDayPrevious);

      const dataPrevious = {
        siteID: Number(site.id),
        categoryID: 1, // 1 -> Energy
        step: selectedFrequency,
        dateStart: formatDateForServer(reportFromDatePrevious.toISOString()),
        dateEnd: formatDateForServer(reportToDatePrevious.toISOString()),
        ids: checkedVariables.map(String),
      };  
      triggerRequestPrevious({ method: "POST", url: "chart-bar-data", data: dataPrevious });
      sessionStorage.setItem('reportFromDate', reportFromDate.toISOString());
      sessionStorage.setItem('reportToDate', reportToDate.toISOString());
      sessionStorage.setItem('selectedFrequency', selectedFrequency);
      sessionStorage.setItem('checkedVariables', JSON.stringify(checkedVariables));
      sessionStorage.setItem('selectedPeriod', selectedPeriod);

      setPeriodDayPrevious(periodDayPrevious);
    }
  },[checkedVariables, reportFromDate, reportToDate, selectedFrequency, site.id, triggerRequest, triggerRequestPrevious, selectedPeriod, paragonSiteID]);

  useEffect(() => {
    search();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportFromDate, reportToDate, selectedFrequency]);

  const onChangeVariableSelection = useCallback((variableId, checked) => {
    setCheckedVariables(checked ? checkedVariables.concat(variableId) : 
      checkedVariables.filter(id => id !== variableId));
  },[checkedVariables]);

  ////DESELEZIONA O SELEZIONA TUTTE LE VARIABILI NELLA MODALE
  const onSelectDeselectAllVariables = useCallback((checked) => {
    setCheckedVariables(checked ? Object.keys(variables).map(Number) : []);
  },[variables]);
  
  ////FUNZIONE PER CAMBIARE, NELLA MODALE DELLE VARIABILI, IL COLORE NEL GRAFICO
  const onChangeVariableColor = useCallback((variableId, color) => {
    setVariables({
      ...variables,
      [variableId]: {
        ...variables[variableId],
        color,
      },
    });
  },[variables]);

  const researchedVariables = (chartDataResponse?.vars || []).map(vars => (  vars.idvar));
  const titleVaribles = `Variabili: ${checkedVariables.length} di ${variablesList.length} selezionate`;
  const titleParVaribles = `paragone tra ${site?.brand} - ${site?.name} e
        ${varListParagon.site?.brand} - ${varListParagon.site?.name}`;

  const configModalVariables = {
    configModal: {
      defaultExpanded:true,
      sxStyle:{width: { xs: "100%", sm: "30%" }},
      search:search,
    },
    configVariablesGrid: {
      variables,
      checkedVariables,
      researchedVariables,
      onChangeSelection:onChangeVariableSelection,
      onChangeColor:onChangeVariableColor,
      onSelectDeselectAll:onSelectDeselectAllVariables,
      showAvg:false,
      title:titleVaribles
    }
  }

  // ///SOMMA LE VARIABILI DEGLI ARRAY PRENDENDO LA CORRISPONDENZA IN BASE ALLA POSIZIONE
  // const sumChartGroupData = (chartVars = [], associazioni = [], key = "paragoni") => {
  //   if (chartVars.length === 0 || associazioni.length === 0) return [];
    
  //   return associazioni.map((assoc, index) => {
  //     const { nome } = assoc;
  //     const ids = assoc[key]; // può essere "paragoni" o "principali"
  
  //     const varsInGroup = chartVars.filter(v => ids.includes(v.idvar));
  //     const numPoints = varsInGroup[0]?.data.length || 0;
      
  //     const summedData = Array.from({ length: numPoints }, (_, i) => {
  //       const time = varsInGroup[0].data[i]?.time;
  //       const valueSum = varsInGroup.reduce((sum, curr) => {
  //         const value = curr.data[i]?.value ?? 0;
  //         return sum + value; 
  //       }, 0);
  //       return { x: time, y: valueSum };
  //     });
  //     console.log(summedData)
  //     const colorBase = assoc.color || generateRandomColor();
  //     const isParagon = key === "paragoni";
  //     const color = isParagon ? transparentize(0.4, colorBase) : colorBase;
  //     console.log(summedData)
  //     return {
  //       label: nome || `Gruppo ${index + 1}`,
  //       data: summedData,
  //       backgroundColor: color,
  //       borderColor: color,
  //       borderWidth: 1,
  //     };
  //   });
  // };

  const dateRange = chartDataResponse?.dateRange || [];

  const datasets = useMemo(() => {
    if (paragonSiteID === null && paragonArray.length === 0) {
      const vars = generateDatasetsBar(chartVars || [], variables);
      const varsPrevious = generateDatasetsBar(chartVarsPrevious || [], variables);
      return [
        { name: "dataPrevious", dataset: varsPrevious || [] },
        { name: "currentData", dataset: vars || [] },
      ];
    } else if (paragonArray.length > 0) {
      const datasetsParagon = sumChartGroupData(chartVarsParagon, paragonArray, "paragoni");
      const datasetsPrincipali = sumChartGroupData(chartVars, paragonArray, "principali");
      const datasetsPrincipaliPrevious = sumChartGroupData(chartVarsPrevious, paragonArray, "principali");
      
      return [
        { name: "dataPrevious", dataset: datasetsPrincipaliPrevious },
        { name: "currentData", dataset: [...datasetsPrincipali, ...datasetsParagon] }
      ];
    }
    return [];
  }, [chartVars, chartVarsPrevious, chartVarsParagon, paragonSiteID, variables, paragonArray]);


  const isSitesReady = sitesEnergy?.sites?.length > 0;

  const renderModalEnergySite = () => {
    const propsModalEnergySite = {
        sitesEnergy,setParagonSiteID,setOpenModalEnergySite,setOpenModalPar,openModalEnergySite}
    return <ModalEnergySite {...propsModalEnergySite}/>
  }

  const renderModalParagon = () => {
    const propsModalVarParagon = {
      site,varListParagon,variablesList,
      openModalPar,setOpenModalPar,setParagonArray,paragonArray
    }
    return <ModalVarParagon {...propsModalVarParagon}/>
  }

  const handleParagonEnergySites = useCallback(() => {
    if (paragonSiteID === null) {
      return setOpenModalEnergySite(true)
    }
    return setOpenModalPar(true)
  },[paragonSiteID])

  ///CANCELLA IL PARAGONE
  const clearParagon = useCallback(() => {
    setParagonSiteID(null);
    setParagonArray([]);
    setChartVarsParagon([]);
    setActiveParagon(false);
  }, []);

  const chartBarProps = { datasets, dateRange, 
    titleVaribles: paragonSiteID !== null && paragonArray.length !== 0 ? 
      titleParVaribles :
      titleVaribles,
    activeParagon,periodDayPrevious}

  const footerProps = {selectedFrequency, reportToDate, reportFromDate, site, checkedVariables, 
            selectedPeriod,setReportFromDate, setReportToDate, setSelectedFrequency, 
            setSelectedPeriod,onClickParagon,paragonSiteID, activeParagon, handleParagonEnergySites}
  
  return (
    <>
      {chartLoading && isLoading28DaysAgo && LoadingEnergySites && <LinearProgress/>}
      {paragonSiteID !== null && (
        <Grid>
          <Chip
            label={titleParVaribles}
            onDelete={clearParagon}
            sx={{ mt: 1, mb: 2, fontSize: '0.9rem', maxWidth: '100%',backgroundColor:"primary.main", color:"white"}}
            variant="outlined"/>
        </Grid>
      )}
      <ChartBar {...chartBarProps}/>
      {openModalPar && renderModalParagon()}
      {openModalEnergySite && isSitesReady && renderModalEnergySite()}
      {modalPortal && 
      paragonSiteID === null &&
        ReactDOM.createPortal(<ModalVariables {...configModalVariables}/>, modalPortal)} 
      <EnergyFooter {...footerProps}/>   
    </>
  );
}
